import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import ContentLayout from "../../components/ContentLayout";
import Basic_Research_methodology_july_2024 from "../../static_data/event_image/MHUS/2024-25/Basic_Research_methodology_july_2024.json";
import Basic_Research_methodology_January_2025 from "../../static_data/event_image/MHUS/2024-25/Basic_Research_methodology_january_2025.json";
import TOT from "../../static_data/event_image/MHUS/2024-25/TOT_Competency_Based_Syllabus.json";
import FoundationDay2025 from "../../static_data/event_image/MHUS/2024-25/MUHS_Foundation_day_2025.json";
import METWorkshop2025 from "../../static_data/event_image/MHUS/2024-25/MET_workshop_2025.json";

type Years = Array<DataItem>;

type DataItem = {
  year: string;
  data: Array<MUHSEventObject>;
};

type EventsProps = {
  data: Array<MUHSEventObject>;
};

type ImageType = {
  src: string;
  alt: string;
};

type MUHSEventObject = {
  title: string;
  description?: string;
  img?: Array<ImageType>;
  date?: Date | String;
};

const MUSHEventsData_2025_26: MUHSEventObject[] = [
    {
    title: "MET Workshop 2025",
    img: METWorkshop2025.images.map((image: { src: string; title: string }) => ({
      src: require(`../../assets/images/events/MUHS/MET_workshop_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "18 June 2025",
  },
   {
    title: "MUHS Foundation Day 2025",
    img: FoundationDay2025.images.map((image: { src: string; title: string }) => ({
      src: require(`../../assets/images/events/MUHS/MUHS_Foundation_day_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "17 June 2025",
  },
];

//src\assets\images\events\MUHS
const MUSHEventsData_2024_25: MUHSEventObject[] = [

    {
    title: "TOT Competency Based Syllabus Workshop",
    img: TOT.images.map((image: { src: string; title: string }) => ({
      src: require(`../../assets/images/events/MUHS/TOT_Competency_Based_Syllabus_Workshop/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Basic Research methodology January 2025",
    img: Basic_Research_methodology_January_2025.images.map((image: { src: string; title: string }) => ({
      src: require(`../../assets/images/events/MUHS/BASIC_RESEARCH_METHODOLOGY_JANUARY_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Basic Research methodology july 2024",
    img: Basic_Research_methodology_july_2024.images.map((image: { src: string; title: string }) => ({
      src: require(`../../assets/images/events/MUHS/BASIC_RESEARCH_METHODOLOGY_JULY_2024/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  // ...existing code...
];

const MUSHEventsData_2023_24: MUHSEventObject[] = [];
const MUSHEventsData_2022_23: MUHSEventObject[] = [];
const MUSHEventsData_2021_22: MUHSEventObject[] = [];
const MUSHEventsData_2020_21: MUHSEventObject[] = [];
const MUSHEventsData_2019_20: MUHSEventObject[] = [];

const years: DataItem[] = [
   { year: "2025-26", data: MUSHEventsData_2025_26 },
  { year: "2024-25", data: MUSHEventsData_2024_25 },
  { year: "2023-24", data: MUSHEventsData_2023_24 },
];

const RenderEvent = ({ data }: EventsProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <>
      {data?.map((item, index) => {
        const isMultiImages = Array.isArray(item?.img) && item?.img?.length > 1;
        const imageToShow = (item?.img ? item?.img[0]?.src : "") as string;
        return (
          <Grid
            key={index}
            item
            p={2}
            margin={"auto"}
            flexWrap={"wrap"}
            sx={{
              minWidth: {
                xs: "100%",
                md: 400,
              },
              maxWidth: {
                xs: "100%",
                md: 400,
              },
            }}
          >
            <Card
              sx={{
                alignContent: "space-between",
                minWidth: {
                  xs: "100%",
                },
                maxWidth: {
                  xs: "100%",
                },
                minHeight: "400px",
                maxHeight: "400px",
                position: "relative",
              }}
            >
              {
                <>
                  {isMultiImages ? (
                    <Box sx={{ position: "relative" }}>
                      <ImageSlideshow
                        sx={{}}
                        images={item?.img as Array<ImageType>}
                        showCaption={false}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 99,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ position: "relative" }}>
                      <CardMedia
                        component="img"
                        height="240px"
                        sx={{
                          pt: 1,
                          margin: "auto",
                          objectFit: "cover",
                        }}
                        image={imageToShow}
                        alt={item?.title as string}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 2,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                  <Divider sx={{ py: 1 }} />
                </>
              }
              <CardContent>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.contrastText,
                      padding: "10px",
                    }}
                  >
                    {item?.title}
                  </Typography>
                  {item?.description && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: theme.palette.grey[900],
                        p: 2,
                      }}
                    >
                      {item?.description}
                    </Typography>
                  )}
                </Box>
              </CardContent>
              <Typography
                sx={{
                  color: "black",
                  position: "absolute",
                  bottom: 16,
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                {item?.date?.toString()}
              </Typography>
            </Card>
          </Grid>
        );
      })}
      {data?.length === 0 && <Box sx={{ p: 4 }}>No Data</Box>}
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={
            <Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>
          }
        />
      )}
    </>
  );
};

const MUHSEventWorkshops = () => {
  const [year, setYear] = useState("2025-26");

  const YearTabs = () => (
    <Grid container spacing={2} justifyContent="center">
      {years?.map((item) => (
        <Grid item key={item?.year} xs="auto" sx={{ my: { sm: 1, md: 4 } }}>
          <Chip
            label={item?.year}
            variant="filled"
            sx={{
              color: item?.year === year ? "secondary.main" : "white",
              backgroundColor:
                item?.year === year ? "transparent" : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
            onClick={() => setYear(item?.year)}
          />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <ContentLayout>
      <React.Fragment>
        <YearTabs />

        <RenderEvent
          data={
            years.find((item) => item.year === year)
              ?.data as Array<MUHSEventObject>
          }
        />
      </React.Fragment>
    </ContentLayout>
  );
};

export default MUHSEventWorkshops;
